import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // Expresión regular para caracteres españoles, números y espacios
  // Incluye: a-z, A-Z, 0-9, ñ, Ñ, acentos (á, é, í, ó, ú, à, è, ì, ò, ù, ä, ë, ï, ö, ü)
  spanishPattern = /^[a-zA-Z0-9áéíóúàèìòùäëïöüÁÉÍÓÚÀÈÌÒÙÄËÏÖÜñÑ\s]*$/;

  connect() {
    this.element.addEventListener("input", (e) => this.filterInput(e));
  }

  filterInput(event) {
    const input = event.target;
    const originalValue = input.value;

    // Filtrar caracteres no permitidos
    const filteredValue = originalValue
      .split("")
      .filter((char) => this.spanishPattern.test(char))
      .join("");

    // Si el valor cambió, actualizar el input
    if (filteredValue !== originalValue) {
      input.value = filteredValue;
      // Disparar evento de cambio para que se detecte el cambio
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}
